module.exports = __webpack_public_path__ + "static/media/collab.1d33a07c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/agency/assets/collab.png
// module id = 235
// module chunks = 0